import React from "react";

import Select from "./index";

export default function Tax(props) {
  const items = ["GROSS", "NET", "NONE"];

  return <Select label="Tax" items={items} {...props} />;
}
